import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../_service/utility';
@Pipe({
  name: 'absUrl'
})
export class AbsUrlPipe implements PipeTransform {
  constructor(private _utility:Utility){}

  transform(resource:string): string {
    return this._utility.getAbsUrl(resource);
  }


}
@Pipe({
  name: 'absBgUrl'
})
export class AbsUrlBackgroundPipe implements PipeTransform {
  constructor(private _utility:Utility){}


  transform(resource:string): object {
    return  {'background-image':'url("'+this._utility.GetHost(resource) +'")'};
  }

}
